import { RowVehicleApplicationVersionDto } from "@/dtos";
import { VehicleApplicationVersion } from "@/entities";
import { getVehicleApplicationVersion } from "@/helpers/options";
import { parseToLocalDateTimeFromUtc } from "@/helpers/utilities";

export const formatRowVehicleApplicationVersion = (vehicleApplicationVersions: VehicleApplicationVersion[]) => {
    return vehicleApplicationVersions.map(x => {
        const row: RowVehicleApplicationVersionDto = {
            ...x,
            company_label: x.company.name,
            vehicle_label: x.vehicle.name,
            application_version_label: x.applicationVersion.name,
            status_label: getVehicleApplicationVersion(x.status).label,
            shipping_date_label: x.shipping_date ? parseToLocalDateTimeFromUtc(x.shipping_date.toString()) : '',
            installation_date_label: x.installation_date ? parseToLocalDateTimeFromUtc(x.installation_date.toString()) : '',
            active: x.is_active ? 'Activo' : 'Inactivo',
        }

        return row;
    });
}